import { render, staticRenderFns } from "./videoBox.vue?vue&type=template&id=9c4425fc&scoped=true"
import script from "./videoBox.vue?vue&type=script&lang=js"
export * from "./videoBox.vue?vue&type=script&lang=js"
import style0 from "./videoBox.vue?vue&type=style&index=0&id=9c4425fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4425fc",
  null
  
)

export default component.exports